import React from "react";
import Modal from "../../../Base/Modal";

export default function InvoiceModal(props) {
  console.log(props)
  return (
    <Modal close={props.close} title={props.title}>
      <div className="modal__invoice">
        <div className="modal__info">
          <p className="sm">Time</p>
          <p className="med">{props?.payment?.timestamp}</p>
        </div>
        <div className="modal__info">
          <p className="sm">Receipt ID</p>
          <p className="med">{props?.id}</p>
        </div>
        <div className="modal__info">
          <p className="sm">Sender Address</p>
          <p className="med">{props?.payment?.payerAddress}</p>
        </div>
        {/* <div className="modal__info">
          <p className="sm">Sender name:</p>
          <p className="med">{props?.senderName}</p>
        </div> */}
        <div className="modal__info">
          <p className="sm">Receiver:</p>
          <p className="med">{props?.payment?.receiverAddress}</p>
        </div>
        <div className="modal__info">
          <p className="sm">Chain:</p>
          <p className="med">{props?.payment?.networkId}</p>
        </div>
        <div className="modal__info">
          <p className="sm">Amount:</p>
          <p className="med">{Number(props?.amountUsd).toFixed(2)}</p>
        </div>
        <div className="modal__info">
          <p className="sm">Token</p>
          <p className="med">{props?.payment?.token?.name}</p>
        </div>
      </div>
    </Modal>
  );
}
